export default __webpack_public_path__ + "static/media/expand.87e8619f.png";